import { useState } from "react";

import BuilderDesktopSidebar from "./BuilderDesktopSidebar";
import BuilderMobileDrawer from "./BuilderMobileDrawer";
import BuilderMobileHeader from "./BuilderMobileHeader";
import { LibraryBig } from "lucide-react";


export default function BuilderLayout({

    title = "Builder Library",
    width=310,
    sidebar,

    toolbar,

    children,

    footer,

    action,

    onAction

}){

    const [

        drawerOpen,

        setDrawerOpen

    ] = useState(false);

    return(

        <>

            <BuilderMobileHeader

                title={title}

                action={action}

                onAction={onAction}

                onMenu={()=>

                    setDrawerOpen(true)

                }

            />

            <BuilderMobileDrawer

                title={title}

                open={drawerOpen}

                onClose={()=>

                    setDrawerOpen(false)

                }

            ><div className="media-sidebar">

    <div className="sidebar-header">

        <div className="sidebar-title">
            <LibraryBig size={22}/>
            <div>
                <h3>{title}</h3>
            </div>
        </div>

    </div>


                {sidebar}
</div>
            </BuilderMobileDrawer>

            <div className="media-layout">

                <BuilderDesktopSidebar>

                  <div className="media-sidebar">

    <div className="sidebar-header">

        <div className="sidebar-title">
            <LibraryBig size={22}/>
            <div>
                <h3>{title}</h3>
            </div>
        </div>

    </div>


                {sidebar}
</div>

                </BuilderDesktopSidebar>

                <main className="media-layout-content">

                    {

                        toolbar &&

                        <div className="media-layout-toolbar">

                            {toolbar}

                        </div>

                    }

                    <section className="media-layout-body">

                        {children}

                    </section>

                    {

                        footer &&

                        <div className="media-layout-footer">

                            {footer}

                        </div>

                    }

                </main>

            </div>

<style>{`

.media-layout{

    display:grid;margin-top:0px;

    grid-template-columns:${width}px minmax(0,1fr);

    gap:4px;
    position:relative;
    align-items:start;

}

/* ---------- Sidebar ---------- */

.media-desktop-sidebar{

    position:sticky;

    top:72px;

    align-self:start;

    height:calc(100vh - 90px);

    overflow:hidden;

}

/* ---------- Right ---------- */

.media-layout-content{

    min-width:0;

    display:flex;

    flex-direction:column;

    gap:18px;

}

.media-layout-toolbar{

    flex-shrink:0;

}

.media-layout-body{

    min-width:0;

    overflow:auto;

}

.media-layout-footer{

    display:flex;

    justify-content:flex-end;

}

/* ---------- Large Desktop ---------- */

@media(max-width:1400px){

.media-layout{

    grid-template-columns:280px minmax(0,1fr);

}

}

/* ---------- Laptop ---------- */

@media(max-width:1200px){

.media-layout{

    grid-template-columns:250px minmax(0,1fr);

    gap:18px;

}

}

/* ---------- Tablet ---------- */

@media(max-width:992px){

.media-layout{

    display:block;

}

.media-desktop-sidebar{

    display:none;

}

.media-layout-content{

    width:100%;

}

.media-layout-toolbar{

    margin-top:16px;

}

}

/* ---------- Mobile ---------- */

@media(max-width:768px){

.media-layout{

    padding:0;

}

.media-layout-content{

    gap:14px;

}

.media-layout-footer{

    justify-content:center;

}

}



.media-sidebar{


   
    height:90vh !important;


    background:#FAFBFC;

    border-right:1px solid #E5E7EB;

    overflow-y:auto !important;
overflow-x:hidden;
}

.sidebar-header{

    padding:22px 22px 18px;

    border-bottom:1px solid #EEF2F7;

    background:#FFF;

}

.sidebar-title{

    display:flex;

    align-items:center;

    gap:14px;

}

.sidebar-title svg{

    color:rgba(144, 202, 249,1);

}

.sidebar-title h3{

    margin:0;

    font-size:20px;

    font-weight:700;

    color:#0F172A;

}

.sidebar-title span{

    font-size:13px;

    color:#64748B;

}

.sidebar-item{

    margin:10px 12px 0;

    padding:12px 14px;

    border-radius:12px;

    display:flex;

    justify-content:space-between;

    align-items:center;

    cursor:pointer;

    transition:.18s;

}

.sidebar-item:hover{

    background:#F1F5F9;

}

.sidebar-item.active{

    background:#E8F1FF;

    color:rgba(144, 202, 249,1);

    font-weight:600;

}

.sidebar-item.active svg{

  color:#2563EB;

}

.sidebar-left{

    display:flex;

    align-items:center;

    gap:12px;

}

.sidebar-left svg{

    color:#64748B;

}

.sidebar-divider{

    margin:16px 18px;

    border-top:1px solid #EEF2F7;

}

.sidebar-content{

    flex:1;

    overflow:auto;

}

.sidebar-footer{

    margin-top:auto;

    padding:18px;

    border-top:1px solid #EEF2F7;

    background:#FFF;

}

.create-list-btn{

    width:100%;

    height:46px;

    border:none;

    border-radius:12px;

    display:flex;

    align-items:center;

    justify-content:center;

    gap:8px;

    cursor:pointer;

    background:rgba(144, 202, 249,1);

    color:#FFF;

    font-size:14px;

    font-weight:600;

    transition:.18s;

}

.create-list-btn:hover{

    background:#1D4ED8;

}

.sidebar-loading{

    height:18px;

    margin:12px 18px;

    border-radius:8px;

    background:#ECEFF3;

    animation:pulse 1.2s infinite;

}

@keyframes pulse{

    50%{

        opacity:.45;

    }

}

.media-sidebar::-webkit-scrollbar{

    width:8px;

}

.media-sidebar::-webkit-scrollbar-thumb{

    background:#CBD5E1;

    border-radius:20px;

}

.media-sidebar::-webkit-scrollbar-thumb:hover{

    background:#94A3B8;

}


`}</style>

        </>

    );

}